<div class="personnel-mgnt-group">
  <div class="container">
    <div class="row">
      <!-- <div class="col list-group-links">
        <ul class="list-group">
          <li class="list-group-item" [routerLinkActive]="['active']" [routerLink]="['driver']">Driver</li>
          <li class="list-group-item" [routerLinkActive]="['active']" [routerLink]="['controller']">Controller</li>
        </ul>
      </div> -->
      <div class="col pm-content">
        <!-- <app-settings-ladder></app-settings-ladder> -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>